import { render, staticRenderFns } from "./memberCardBuy.vue?vue&type=template&id=23e9715d&scoped=true&"
import script from "./memberCardBuy.vue?vue&type=script&lang=js&"
export * from "./memberCardBuy.vue?vue&type=script&lang=js&"
import style0 from "./memberCardBuy.vue?vue&type=style&index=0&id=23e9715d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9715d",
  null
  
)

export default component.exports